<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title> Ajouter des assemblages </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <div class="d-flex flex-wrap ga-2">
            <v-chip
              :closable="!selectedComposite.selected"
              @update:model-value="removeComposite(selectedComposite)"
              v-for="selectedComposite in selectedComposites"
              :key="selectedComposite.compositePrototypeId"
            >
              {{ selectedComposite.name }}
            </v-chip>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field label="Recherche" v-model="searchValue" clearable @click:clear="resetFilter"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0" :gap="0">
          <v-col
            cols="3"
            class="d-flex pa-0"
            v-for="composite in filteredComposites"
            :key="composite.compositePrototypeId"
          >
            <div class="composite-name-container">
              <span class="composite-name-block">
                <span
                  :class="[
                    'composite-name-text',
                    composite.selected ? 'selected' : '',
                    composite.selectedNew ? 'selected-new' : '',
                  ]"
                  @click="addComposite(composite)"
                >
                  {{ composite.name }}
                </span>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="elevated" @click="cancel"> Annuler </v-btn>
      <v-btn color="primary" variant="elevated" @click="confirm"> Confirmer </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { GetCompositesFromPhase } from '@/_services/phases';
import { AddComposite } from '@/_services/jobs';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'CompositeAddDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  data() {
    return {
      searchValue: '',
      allComposites: [],
      selectedComposites: [],
      availableComposites: [],
      filteredComposites: [],
    };
  },
  methods: {
    fetchComposites() {
      this.$emit('loading');
      GetCompositesFromPhase(this.payload.phase.id, true)
        .then(rep => {
          const availableComposites = rep.data.map(x => ({
            ...x,
            selected: false,
            selectedNew: false,
          }));

          const selectedComposites = this.payload.phase.compositesDTO
            ? this.payload.phase.compositesDTO.map(x => ({
                ...x,
                selected: true,
                selectedNew: false,
              }))
            : [];

          const availableCompositesFiltered = availableComposites.filter(
            x => !selectedComposites.some(d => d.compositePrototypeId === x.id),
          );

          this.selectedComposites = selectedComposites;
          this.availableComposites = availableCompositesFiltered;
          this.allComposites = selectedComposites.concat(availableCompositesFiltered);
          this.filteredComposites = this.allComposites;
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.$emit('loading', false);
        });
    },
    addComposite(composite) {
      if (!this.selectedComposites.includes(composite)) {
        this.selectedComposites.push(composite);
        const compositeIndex = this.filteredComposites.indexOf(composite);
        this.filteredComposites[compositeIndex].selectedNew = true;
      }
    },
    filterComposites() {
      if (this.searchValue !== null) {
        const search = this.searchValue.toLowerCase();

        this.filteredComposites = this.allComposites.filter(({ name }) => name.toLowerCase().includes(search));
      }
    },
    resetFilter() {
      this.searchValue = '';
      this.filteredComposites = this.allComposites;
    },
    removeComposite(selectedComposite) {
      const selectedCompositeIndex = this.selectedComposites.indexOf(selectedComposite);
      this.selectedComposites.splice(selectedCompositeIndex, 1);
      const compositeIndex = this.filteredComposites.indexOf(selectedComposite);
      this.filteredComposites[compositeIndex].selectedNew = false;
    },
    cancel() {
      this.searchValue = '';
      this.$emit('close');
    },
    confirm() {
      this.$emit('loading');

      const requests = this.selectedComposites
        .filter(({ selected }) => !selected)
        .map(({ id }) =>
          AddComposite(this.$store.getters['submission/getJobId'], id).then(composite => {
            this.$store.dispatch('job/addComposite', {
              composite: composite,
              phaseId: this.payload.phase.id,
            });
          }),
        );

      Promise.all(requests)
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
  },
  watch: {
    searchValue() {
      this.filterComposites();
    },
  },
  mounted() {
    this.fetchComposites();
  },
};
</script>
